export default __webpack_public_path__ + "static/media/food11.fd6fdc75.png";